/*Footer*/
function Footer() {
  return (
    <footer>
      Designed &amp; Developed by <span>Ricardo Martins</span> · ©{" "}
      {new Date().getFullYear()}
    </footer>
  );
}

export default Footer;
